module.exports = __webpack_public_path__ + "static/media/night_flight_sample_3.c3d5179c.jpg";